function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.008 7.468l.026-.025-.02-.03c-.476-.75-.422-1.744.228-2.394l1.41-1.41a1.93 1.93 0 011.37-.564c.496 0 .992.188 1.368.564a1.943 1.943 0 010 2.739l-1.41 1.41c-.65.65-1.643.704-2.393.228l-.03-.02-.026.026-.54.54-.025.025.02.03c.476.75.422 1.744-.228 2.394l-1.41 1.41a1.944 1.944 0 01-2.738 0 1.943 1.943 0 010-2.74l1.41-1.41c.65-.65 1.643-.703 2.393-.227l.03.02.026-.026.54-.54zm1.11-.062l-.047.046.06.027c.438.195.964.118 1.327-.244l1.41-1.41a1.19 1.19 0 000-1.692 1.193 1.193 0 00-1.693 0l-1.41 1.41c-.362.362-.44.888-.244 1.326l.027.06.046-.046.907-.907h0a.37.37 0 11.524.523h-.001l-.907.907zM6.882 8.594l.046-.046-.06-.027a1.182 1.182 0 00-.48-.109c-.305 0-.61.118-.846.353l-1.41 1.41a1.19 1.19 0 000 1.692h0a1.19 1.19 0 001.692 0l1.41-1.41c.363-.362.439-.888.244-1.326l-.027-.06-.046.046-.906.906h0v.001a.371.371 0 01-.61-.116.37.37 0 01.086-.407h0l.907-.907z",
  fill: "#616161",
  stroke: "#F2F2F5",
  strokeWidth: 0.09
});

function SvgRelateActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgRelateActivity;